import script from "./StartScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartScreen.vue?vue&type=script&setup=true&lang=ts"

import "./StartScreen.vue?vue&type=style&index=0&id=b4048a72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4048a72"]])

export default __exports__